function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8 .5A7.493 7.493 0 0 0 .5 8c0 4.148 3.353 7.5 7.5 7.5 4.148 0 7.5-3.352 7.5-7.5C15.5 3.853 12.148.5 8 .5zm3.75 10.193l-1.057 1.057L8 9.057 5.308 11.75 4.25 10.693 6.942 8 4.25 5.308 5.308 4.25 8 6.942l2.693-2.692 1.057 1.058L9.057 8l2.693 2.693z"
});
const SvgIcCancel = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 18,
  viewBox: "0 0 18 18",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcCancel, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-cancel.c4ba4741.svg";
export { ForwardRef as ReactComponent };